import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=240cb895&"
import script from "./ClientForm.vue?vue&type=script&lang=ts&"
export * from "./ClientForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports